/**
 * Created by dushyantha on 7/12/16.
 */
(function () {
    'use strict';

    /* @ngdoc object
     * @name crewSchedule
     * @description
     *
     */
    angular
        .module('crewSchedule', [
            'ui.router'
        ]);
}());
